<div class="page-header">
  <div class="title-section">
    <h2 class="page-title">Nouveau sous-traitant</h2>
    <p class="page-subtitle">Remplissez les informations pour enregistrer un nouveau sous-traitant</p>
  </div>
  <a routerLink="/sous-traitants" class="btn btn-outline btn-with-icon back-link">
    <mat-icon aria-hidden="true">arrow_back</mat-icon>
    Retour à la liste
  </a>
</div>

<div class="form-container">
  <div class="card shadow-sm">
    <form [formGroup]="stForm" (ngSubmit)="onSubmit()" class="modern-form">
      <div class="form-section">
        <h3 class="section-title">Informations administratives</h3>
        <div class="form-row">
          <div class="form-group col">
            <label for="codeComptable">CODE COMPTABLE</label>
            <input type="text" id="codeComptable" formControlName="codeComptable" class="form-control" placeholder="ex: 401ST001">
            @if (stForm.get('codeComptable')?.touched && stForm.get('codeComptable')?.errors?.['required']) {
              <div class="field-error">Le code comptable est requis.</div>
            }
          </div>
          <div class="form-group col">
            <label for="siret">SIRET</label>
            <input type="text" id="siret" formControlName="siret" class="form-control" placeholder="14 chiffres">
            @if (stForm.get('siret')?.touched && stForm.get('siret')?.errors?.['siret']) {
              <div class="field-error">Le SIRET doit contenir exactement 14 chiffres.</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="denomination">DÉNOMINATION / NOM</label>
            <input type="text" id="denomination" formControlName="denomination" class="form-control" placeholder="Nom du sous-traitant">
            @if (stForm.get('denomination')?.touched && stForm.get('denomination')?.errors?.['required']) {
              <div class="field-error">La dénomination est requise.</div>
            }
          </div>
          <div class="form-group col">
            <label for="qualification">QUALIFICATION</label>
            <input type="text" id="qualification" formControlName="qualification" class="form-control" placeholder="ex: Électricité, Plomberie">
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">Adresse et Localisation</h3>
        <div class="form-row">
          <div class="form-group col">
            <label for="adresse">ADRESSE</label>
            <input type="text" id="adresse" formControlName="adresse" class="form-control">
            @if (stForm.get('adresse')?.touched && stForm.get('adresse')?.errors?.['required']) {
              <div class="field-error">L'adresse est requise.</div>
            }
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col">
            <label for="ville">VILLE</label>
            <input type="text" id="ville" formControlName="ville" class="form-control">
            @if (stForm.get('ville')?.touched && stForm.get('ville')?.errors?.['required']) {
              <div class="field-error">La ville est requise.</div>
            }
          </div>
          <div class="form-group col">
            <label for="codePostal">CODE POSTAL</label>
            <input type="text" id="codePostal" formControlName="codePostal" class="form-control">
            @if (stForm.get('codePostal')?.touched && stForm.get('codePostal')?.invalid) {
              <div class="field-error">
                @if (stForm.get('codePostal')?.errors?.['required']) {
                  <span>Le code postal est requis.</span>
                }
                @if (stForm.get('codePostal')?.errors?.['codePostal']) {
                  <span>Le code postal doit contenir 5 chiffres.</span>
                }
              </div>
            }
          </div>
        </div>
      </div>

      @if (errorMessage()) {
        <div class="error-banner">{{ errorMessage() }}</div>
      }

      <div class="form-actions">
        <button type="button" routerLink="/sous-traitants" class="btn btn-outline">Annuler</button>
        <button type="submit" [disabled]="stForm.invalid || isLoading()" class="btn btn-primary">
          {{ isLoading() ? 'Création en cours...' : 'Créer le sous-traitant' }}
        </button>
      </div>
    </form>
  </div>
</div>

<style>
.field-error {
  color: #c62828;
  font-size: 12px;
  margin-top: 4px;
}
/* Rendre visuellement les boutons disabled bien grisés et inactifs */
.btn[disabled] {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
